import { useCallback } from 'react'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import { array, func, string } from 'prop-types'

export const CvsNoCheckmarkHeader = ({ columns, order, orderBy, onRequestSort }) => {
  const createSortHandler = useCallback(
    (property, index) => event => {
      onRequestSort(event, property.label, index)
    },
    [onRequestSort],
  )

  return (
    <TableHead>
      <TableRow>
        {columns.map((col, index) => (
          <TableCell
            style={{ backgroundColor: 'white', paddingLeft: '15px' }}
            key={col.label}
            align={col ? 'left' : 'right'}
            padding={col ? 'none' : 'default'}
            sortDirection={orderBy === col ? order : false}
          >
            <TableSortLabel
              active={orderBy === col}
              direction={order}
              onClick={createSortHandler(col, index)}
            >
              {col.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}

CvsNoCheckmarkHeader.propTypes = {
  columns: array.isRequired,
  onRequestSort: func.isRequired,
  order: string.isRequired,
  orderBy: string.isRequired,
}
